/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import React, { useEffect } from "react"

interface DataTableProps {
  caption: string | null
  tableData: Record<string, (string | number)[]>
  onRendered?: () => void
}

const DataTable: React.FC<DataTableProps> = ({ caption, tableData, onRendered }) => {
  const headers = Object.keys(tableData)
  // Assume each column array is of equal length.
  const numRows = tableData[headers[0]].length

  useEffect(() => {
    if (onRendered) {
      onRendered()
    }
  }, [onRendered])

  return (
    <>
      {caption && <h3 className="fs-5">{caption}</h3>}
      <table className="mb-4 table table-striped table-sm caption-top">
        <thead>
          <tr>
            {headers.map(header => (
              <th key={header} scope="col">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: numRows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header, colIndex) =>
                colIndex === 0 ? (
                  <th key={header} scope="row">
                    {tableData[header][rowIndex]}
                  </th>
                ) : (
                  <td key={header}>{tableData[header][rowIndex]}</td>
                )
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default DataTable
